import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M30.3 0C13.6 0 0 10.1 0 22.5S13.6 45 30.3 45c8 0 14.6-10.1 14.6-22.5S38.4 0 30.3 0zm-7.5 3.3c-1.3 1.3-2.6 2.9-3.6 4.7-7 2-12.4 5.1-15.6 8.9 2.7-6.6 10-11.8 19.2-13.6zM2.7 24.6c1-7.5 9.7-11.7 15.1-13.6-1.3 3.4-2 7.3-2 11.5 0 8.1 2.8 15.3 7 19.2C12 39.5 3.9 32.8 2.7 24.6zm27.6 17.9c-6.7 0-12.1-9-12.1-20s5.4-20 12.1-20 12.1 9 12.1 20-5.4 20-12.1 20z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M30.3 5c-5.1 0-9.6 8.2-9.6 17.5S25.2 40 30.3 40s9.6-8.2 9.6-17.5S35.4 5 30.3 5zm0 32.5c-2.8 0-7.1-6-7.1-15s4.3-15 7.1-15 7.1 6 7.1 15-4.2 15-7.1 15z"
	})] }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M30.3 5h.3l2.1-2.1c-.8-.3-1.6-.4-2.4-.4-.3 0-.6 0-.8.1L20.1 12c-.6 1.5-1 3.2-1.3 4.9l3.5-3.5C24 8.4 27 5 30.3 5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M34.9 7.2l1.8-1.8c-.6-.6-1.3-1.2-2-1.6l-1.8 1.8c.6.5 1.3 1 2 1.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M21.2 17.3l-2.9 2.9c-.1.8-.1 1.5-.1 2.3v1.3l2.5-2.5c.1-1.4.3-2.7.5-4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M37.5 11.1l1.9-1.9c-.5-.8-.9-1.5-1.4-2.2l-1.8 1.8c.4.7.9 1.4 1.3 2.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M20.8 24.2l-2.3 2.3c.1 1 .3 2.1.5 3l2.1-2.1c-.1-1.1-.2-2.1-.3-3.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M39.1 15.8l2.1-2.1c-.3-.9-.6-1.8-.9-2.6l-2 2c.3.9.6 1.8.8 2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M21.7 29.7l-2 2c.3.9.6 1.8 1 2.6l1.9-1.9c-.4-.8-.7-1.7-.9-2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M23.5 34.4l-1.9 1.9c.4.8.9 1.5 1.4 2.1l1.8-1.8c-.5-.7-.9-1.4-1.3-2.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M39.9 21.5l2.3-2.3c-.1-1.1-.3-2.1-.5-3.1l-2.2 2.2c.3 1 .4 2.1.4 3.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M42.4 21.9l-2.5 2.5c-.1 1.4-.3 2.8-.6 4.2l3-3c.1-1 .2-2 .2-3.1-.1-.2-.1-.4-.1-.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M26.2 38.1l-1.8 1.8c.6.6 1.3 1.1 2.1 1.5l1.9-1.9c-.8-.3-1.5-.8-2.2-1.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M30.8 39.9l-2.3 2.3c.6.2 1.2.3 1.8.3.6 0 1.1-.1 1.7-.2l8.1-8.1c.7-1.6 1.2-3.3 1.6-5.2L38 32.7c-1.7 4.1-4.3 7-7.2 7.2z"
		})
	] })]
});
export default SvgIcon;
